'use client';

import { maskitoTransform } from '@maskito/core';
import { useTranslation } from 'react-i18next';

import { InputField, InputFieldProps } from '../input-field/input-field';
import { useCreditCardFields } from './utils';

export type CardExpiryFieldProps = Omit<
  InputFieldProps,
  | 'maskOptions'
  | 'placeholder'
  | 'prefix'
  | 'type'
  | 'minLength'
  | 'maxLength'
  | 'pattern'
>;

export const CardExpiryField: React.FC<CardExpiryFieldProps> = ({
  ...fieldProps
}) => {
  const { validator } = useCreditCardFields();
  const { t } = useTranslation(['checkout']);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    if (value.length === 1 && !value.match('0|1')) {
      value = `0${value}`;
    }

    // TODO: How would we localize this to match placeholder?
    e.target.value = maskitoTransform(value, {
      mask: [...new Array(2).fill(/\d/), '/', ...new Array(2).fill(/\d/)],
    });
  };

  return (
    /*
    // @ts-expect-error: We'll be getting a false error here due to the dynamic nature of the InputField label and aria attributes */
    <InputField
      autoComplete="cc-exp"
      inputMode="numeric"
      label={t('checkout:form.billingFields.expirationDateLabel')}
      validate={(value) =>
        validator.expirationDate(value).isValid
          ? true
          : t('checkout:form.card.expiryInvalid')
      }
      onChange={handleChange}
      placeholder={t('checkout:form.billingFields.expirationDatePlaceholder')}
      {...fieldProps}
    />
  );
};
